"use client";

import {
  PRODUCT_DISPLAY_CONFIG,
  PRODUCT_FIELD_GROUPS,
} from "@/components/debug/product-display-config";
import { SchemaRenderer } from "@/components/debug/SchemaRenderer";
import productSchema from "@/generated/product-schema.json";

interface ProductAttributesRendererProps {
  data: Record<string, unknown>;
}

export function ProductAttributesRenderer({ data }: ProductAttributesRendererProps) {
  return (
    <SchemaRenderer
      schema={productSchema}
      data={data}
      fieldGroups={PRODUCT_FIELD_GROUPS}
      displayConfig={PRODUCT_DISPLAY_CONFIG}
    />
  );
}
